// export const apibaseurl = "http://192.168.1.17:8001";
export const apibaseurl = "https://engine.tp.auptech.in";

export const baseUrl = `/api/v1`;
export const agency_baseUrl = `/api/v1/agency`;
export const agency_authbaseUrl = `/api/v1/agency-auth`;
export const master_baseUrl = `/api/v1/agency`;
export const master_baseUrl1 = `/api/v1/master`;
const admin_baseUrl = `/api/v1/admin`;
export const admin_baseUrl1 = `/api/v1/admin`;
export const trach_case_base_url = "/api/v1/admin/track-case-progress";

const webservice_url = {
  login: `${agency_authbaseUrl}/agency/login`,
  forgot_password: `${agency_authbaseUrl}/agency/forgot-password`,
  verify_forgot_otp: `${agency_authbaseUrl}/agency/verify-otp`,
  reset_password: `${agency_authbaseUrl}/agency/reset-password`,
  change_password: `${agency_authbaseUrl}/change-password`,
  // artifacts
  get_all_artifacts: `${baseUrl}/agency-atrifact`,
  upload_artifacts: `${baseUrl}/agency-atrifact`,
  upload_assistedReports: `${baseUrl}/agency/candidate/show-report`,

  // =======**** ADMIN ****=======
  // dropdown
  get_organization: `${agency_baseUrl}/organizations`,
  get_accounts: `${agency_baseUrl}/accounts`,
  get_locations: `${agency_baseUrl}/locations`,
  get_programs: `${agency_baseUrl}/programs`,
  get_departments: `${agency_baseUrl}/departments`,
  get_managers_by_filters: `${agency_baseUrl}/managers?`,
  get_managers_list: `${agency_baseUrl}/agency-managers`,
  // end dropdown

  // verifier dropdown
  get_organization_by_managerId: `${agency_baseUrl}/organizations/manager`,
  get_accounts_by_managerId: `${agency_baseUrl}/accounts/manager`,
  get_locations_by_managerId: `${agency_baseUrl}/locations/manager`,
  get_programs_by_managerId: `${agency_baseUrl}/programs/manager`,
  get_departments_by_managerId: `${agency_baseUrl}/departments/manager?programId=`,
  // end verifier dropdown

  // add/manage - Manager
  admin_add_manager: `${agency_baseUrl}/agency-manager`,
  get_all_manager_data: `${agency_baseUrl}/agency-manager-profile-map/list`,
  getApplicantAddress: `api/v1/agency-atrifact`,
  get_assigned_programs_to_manager: `${agency_baseUrl}/agency-manager-profile-map/manager/id`,
  assign_program_to_manager: `${agency_baseUrl}/agency-manager-profile-map`,
  delete_program_from_manager: `${agency_baseUrl}/agency-manager-profile-map`,
  // end add/manager - Manager

  // add/manage - Verifier
  get_all_cases_by_filters: `${agency_baseUrl}/admin-manager-assign-project`,
  admin_add_verifier: `${agency_baseUrl}/agency-verifyer`,
  get_all_verifiers: `${agency_baseUrl}/manager-verifier-list`,
  get_cases_by_verifierId: `${agency_baseUrl}/agency-manager-verifyer-cases`,
  assign_case_to_verifier: `${agency_baseUrl}/agency-member-case-map`,
  delete_case_from_verifier: `${agency_baseUrl}/agency-member-case-map`,
  // end add/manage - Verifier

  admin_case_progress_count: `/api/v1/agency/admin-case-progress-count`,
  admin_case_tracking_data: `/api/v1/agency/case-tracking-progress`,

  get_lob_list: `${agency_baseUrl}/list-of-business`,

  // live case
  fetch_live_case_progress_count: `${agency_baseUrl}/admin-live-case-progress-count`,
  fetch_live_case_data: `${agency_baseUrl}/live-case-progress`,

  // hr pending action
  fetch_hr_pending_action_count: `${agency_baseUrl}/admin/hr-action-required/count`,
  get_insufficiency_details: `${baseUrl}/insufficiency/template`,
  fetch_hr_pending_action_data: `${agency_baseUrl}/admin/hr-action-required`,
  get_insufficiency_documents: `${baseUrl}/insufficiency/documents`,

  // case details
  get_case_summary: `${baseUrl}/admin/track-case-progress/case-summary`,
  admin_addMoreChecksAPI: "/api/v1/admin/add-checks",
  // =======**** END ADMIN ****=======

  // ========= Manager by Vishnu =======
  getOrganizations: `${master_baseUrl}/organizations/manager`,
  // ========= END Manager by Vishnu =======

  // Verifier - ZEESHAN Filters Apis
  fetchOrganizations: `${master_baseUrl}/organizations/verifyer`,
  fetchAccounts: `${master_baseUrl}/accounts/verifyer`,
  fetchLocation: `${master_baseUrl}/locations/verifyer`,
  fetchProgram: `${master_baseUrl}/programs/verifyer`,
  fetchDepartment: `${master_baseUrl}/departments/verifyer`,

  // fetch sum
  fetch_tab_count: `${master_baseUrl}/verifier-dashboard-count`,
  search_live_case_progress: `${master_baseUrl}/verifier-live-case-progress`,
  hr_reports: `${master_baseUrl}/hr-action-required-report`,
  hr_action_count: `${master_baseUrl}/hr-action-required/count`,
  fetch_case_details: `${admin_baseUrl}/track-case-progress/case-summary`,
  // End Verifier - ZEESHAN Filters Apis

  // gourav panchal
  GetCaseStatus: `${admin_baseUrl1}/case-statuses`,
  GetArtifactCaseStatus: `/api/v1/agency-atrifact/checks-status`,
  DeleteArtifactCase: `/api/v1/agency-atrifact`,
  UpdateVerifierCaseStatus: `/api/v1/agency-atrifact/change-case-status`,
  GetCheckStatus: `${admin_baseUrl1}/checks/status`,
  caseDetailsAPI: `${trach_case_base_url}/case-summary`,
  updateCaseStatus: `${admin_baseUrl1}/cases/status`,
  getInsufficiencyReportAPI: `${trach_case_base_url}/insufficiency-report`,
  getExpiredInsuffReportAPI: `${trach_case_base_url}/insufficiency-expired-report`,
  ViewLogAPI: `${trach_case_base_url}/case-activity-log`,
  getDepartmentByMultiProgram: `${master_baseUrl1}/programs/departments`,
  getLocationByMultiProject: `${master_baseUrl1}/projects/locations`,
  getProgramByMultiLocation: `${master_baseUrl1}/projects/programs`,
  getDepartmentByMultiProgram: `${master_baseUrl1}/programs/departments`,
  StopCaseTableAPI: `${trach_case_base_url}/stopped-cases-report`,
  getApplicationTableData: `${trach_case_base_url}/track-cases`,

  manager_case_progress_count: `/api/v1/agency/manager-case-progress-count`,
  manager_case_tracking_data: `/api/v1/agency/case-tracking-progress-manager`,
  DownloadAssestedReport: "/api/v1/agency-atrifact",
};

export default webservice_url;

// get_cases_by_verifierId: `${agency_baseUrl}/agency-manager-verifyer-members`,
